import { css } from '@emotion/css';
import {
  ColorsPrimary900,
  ColorsNeutral500,
  Spacings4,
  Spacings6,
  TextTypographyHeading4,
  TextTypographyBody2,
} from '@efexteam/design-tokens';

const container = css({
  width: '100%',
  maxWidth: '550px',
});

const title = css({
  '&&': {
    ...TextTypographyHeading4,
    textAlign: 'center',
    marginBottom: Spacings4,
    fontWeight: 600,
    color: ColorsPrimary900,
  },
});

const description = css({
  '&&': {
    ...TextTypographyBody2,
    textAlign: 'center',
    marginBottom: Spacings6,
    color: ColorsNeutral500,
  },
});

const alertContainer = css({
  marginBottom: Spacings4,
});

const form = css({
  display: 'flex',
  flexDirection: 'column',
  gap: Spacings4,
});

const fieldContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: Spacings4,
});

const buttonContainer = css({
  display: 'flex',
  justifyContent: 'center',
  paddingTop: Spacings4,
});

const submitButton = css({
  width: '100%',
});

const AuthFormContainerStyles = {
  container,
  title,
  description,
  alertContainer,
  form,
  fieldContainer,
  buttonContainer,
  submitButton,
};

export default AuthFormContainerStyles;
